import { PlayerEvent } from '../PlayerEvent';
import { ReactComponent as ScrollIcon } from '@crazyegginc/hatch/dist/images/icon-scroll.svg';

export function ScrollEvent({ timestamp, active, ...rest }) {
  return <PlayerEvent icon={ScrollIcon} title="Scrolled" timestamp={timestamp} active={active} {...rest} />;
}
